module.exports = __webpack_public_path__ + "img/attraction.90a262ef.png";